module.exports = __webpack_public_path__ + "static/media/partner_wuliu.fb7d4f6d.png";